<template>
  <div class="mb-3">
    <v-layout 
      row 
      wrap >
      <template v-if="match.started">
        <v-flex 
          v-for="(set,i) in match.sets"
          v-if="set.events && set.events.length>0"
          :key="`${match.id}_set_events_${i}`" 
          d-block
          xs12>
          <SetChart
            :match="match"
            :index="i" 
            :set="set"/>
        </v-flex>
      </template>
      <template v-else>
        <v-alert 
          :value="true"
          outline 
          color="success" 
          v-html="$t('page.match.notStarted')" />
      </template>
    </v-layout>
  </div>
</template>

<script>
import SetChart from '@/components/Dashboard/Views/Club/Views/WeekMatches/Views/Match/Templates/MatchCard/MatchBoard/Board/MatchCharts/SetChart'
// const debug = require('debug')('OD::MatchCharts')

export default {
  name: 'MatchCharts',
  components: { SetChart },
  props: {
    match: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      entity: 'match',
      menuOpen: false,
    }
  },
  computed: {},
  watch: {},
  created() {},
  methods: {},
}
</script>

<style lang="scss" scoped>

</style>
